// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var Idle = /* #__PURE__ */ (function () {
    function Idle() {

    };
    Idle.value = new Idle();
    return Idle;
})();
var Running = /* #__PURE__ */ (function () {
    function Running(value0) {
        this.value0 = value0;
    };
    Running.create = function (value0) {
        return new Running(value0);
    };
    return Running;
})();
var ExclusiveTask = function (x) {
    return x;
};
var $$new = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return Control_Bind.bind(Monad0.Bind1())(Effect_Class.liftEffect(dictMonadEffect)(Effect_Ref["new"](Idle.value)))(function (state_) {
        return pure1({
            state: state_
        });
    });
};
var cancelledError = /* #__PURE__ */ Effect_Exception.error("Cancelled");
var isCancelledError = function (e) {
    return Unsafe_Reference.unsafeRefEq(e)(cancelledError);
};
var catchCancelled = function (dictMonadError) {
    var catchJust = Control_Monad_Error_Class.catchJust(dictMonadError);
    var pure1 = Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0());
    return function (block) {
        return catchJust(function (e) {
            var $22 = isCancelledError(e);
            if ($22) {
                return new Data_Maybe.Just(e);
            };
            return Data_Maybe.Nothing.value;
        })(block)(function (v) {
            return pure1(Data_Unit.unit);
        });
    };
};
var catchCancelled1 = /* #__PURE__ */ catchCancelled(Effect_Aff.monadErrorAff);
var run = function (v) {
    return function (block) {
        return function __do() {
            var newFiber = Effect_Aff.launchSuspendedAff(block)();
            return Effect_Aff.launchAff_(catchCancelled1(bind1(liftEffect(Effect_Ref.read(v.state)))(function (state) {
                return discard((function () {
                    if (state instanceof Idle) {
                        return pure(Data_Unit.unit);
                    };
                    if (state instanceof Running) {
                        return Effect_Aff.killFiber(cancelledError)(state.value0);
                    };
                    throw new Error("Failed pattern match at Specular.Internal.ExclusiveTask (line 33, column 5 - line 37, column 39): " + [ state.constructor.name ]);
                })())(function () {
                    return discard(liftEffect(Effect_Ref.write(new Running(newFiber))(v.state)))(function () {
                        return discard(Effect_Aff.joinFiber(newFiber))(function () {
                            return liftEffect(Effect_Ref.write(Idle.value)(v.state));
                        });
                    });
                });
            })))();
        };
    };
};
export {
    Idle,
    Running,
    ExclusiveTask,
    $$new as new,
    run,
    cancelledError,
    isCancelledError,
    catchCancelled
};
